import { render, staticRenderFns } from "./perseo_despachos_hoja_ruta_gestion_empacados.vue?vue&type=template&id=189c06f7&scoped=true"
import script from "./perseo_despachos_hoja_ruta_gestion_empacados.vue?vue&type=script&lang=js"
export * from "./perseo_despachos_hoja_ruta_gestion_empacados.vue?vue&type=script&lang=js"
import style0 from "./perseo_despachos_hoja_ruta_gestion_empacados.vue?vue&type=style&index=0&id=189c06f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189c06f7",
  null
  
)

export default component.exports